import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';
import AdvisorDirectory from '@/components/advisor/public/AdvisorDirectory';
import { usePublicAdvisors } from '@/data/public-advisors';

export default function PublicDirectoryPage() {
  const { data: advisors = [], isLoading: loading } = usePublicAdvisors();

  return (
    <div className="min-h-screen w-full bg-background overflow-x-hidden" data-testid="directory-page">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-12 py-8 sm:py-12 overflow-hidden">
        <div className="text-center mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold">Advisor Directory</h1>
          <p className="text-muted-foreground mt-2 text-sm sm:text-base">
            Find a BitSwan Automation Advisor for your business
          </p>
          <Button asChild className="mt-4" data-testid="directory-get-started">
            <Link to="/signup">
              <UserPlus className="h-4 w-4 mr-2" />
              Get started with BitSwan
            </Link>
          </Button>
          <p className="text-xs text-muted-foreground mt-2">
            30 days free, one Bailey server, and the advisor of your choice.
          </p>
        </div>

        <AdvisorDirectory advisors={advisors} loading={loading} />

        <div
          className="mt-16 rounded-lg border bg-muted/30 px-6 py-8 text-center"
          data-testid="become-an-advisor-footer"
        >
          <h2 className="text-lg font-semibold">Are you the one people ask?</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-muted-foreground">
            If you already help companies work out what to automate, bring that
            practice to BitSwan. We supply the platform, the servers and the billing, and send you the customers looking for someone like you.
          </p>
          <Button asChild className="mt-4" data-testid="become-an-advisor-link">
            <Link to="/become-an-advisor">
              <UserPlus className="mr-2 h-4 w-4" />
              Become an automation advisor
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
